import account from './_account'
import branding from './_branding'
import errors from './_errors'
import nav from './_nav'
import shared from './_shared'
import validations from './_validations'
import dashboard from './_dashboard'

export default {
  dashboard,
  account,
  nav,
  branding,
  errors,
  shared,
  validations
}
